import { LanguageProvider } from "./i18n/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import CoursesSection from "./components/CoursesSection";
import TeacherSection from "./components/TeacherSection";
import TeacherGallery from "./components/TeacherGallery";
import PerformanceInfo from "./components/PerformanceInfo";
import Performances from "./components/Performances";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";

export default function App() {
  return (
    <LanguageProvider>
      <div className="app">
        <Header />
        <main>
          <Hero />
          <CoursesSection />
          <TeacherSection />
          <TeacherGallery />
          <PerformanceInfo />
          <Performances />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}
